<template>
  <!-- 患者選択 -->
  <div id="PatientSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>患者<br/>コード</th><td><input type="text" v-model="patientCode" maxlength="10"/></td>
              <th>患者名</th><td><input type="text" v-model="patientName"/></td>
              <th>医療機関名</th><td><input type="text" v-model="hospitalName"/></td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="patientCode" label="患者コード" width="100" sortable>{{props.row.patientCode}}</b-table-column>
              <b-table-column field="patientName" label="患者名" width="100" sortable>{{props.row.patientName}}</b-table-column>
              <b-table-column field="hospitalName" label="医療機関名" width="300" sortable>{{props.row.hospitalName}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "PatientSelectModal",
  props: {
    title:{default:"患者選択"},
    selectPatientCode:{default:""},
    selectPatientName:{default:""},
    selectHospitalName:{default:""},
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      if(!this.patientCode && !this.patientName && !this.hospitalName){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }

      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalCpap.getPatientCodeListPOST({
            body:{
              patientCode: _this.patientCode,
              patientName:  _this.patientName,
              hospitalName: _this.hospitalName,
            }
          });
        },
        async function(result){
          if(result.obj.length < 1){
            _this.showMessage('該当する患者情報は存在しません。');
          }
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
  },
  data() {
    return {
      data: [],
      patientCode:this.selectPatientCode,
      patientName:this.selectPatientName,
      hospitalName:this.selectHospitalName,
      selectedItem: '',
    };
  },
  filters: {},
  components: {},
  async mounted() {}
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/PatientSelectModal.vue